@let sensorBlock = sensorBlockItem();
@if (sensorBlock) {
  <div class="card">
    <div class="header">
      <div class="icon-and-title">
          <div [ngStyle]="{backgroundColor: toRgba(sensorBlock.color, 0.2)}" class="icon">
            <nb-icon icon="temperature-half" pack="fas"></nb-icon>
          </div>
          <div class="title">{{ sensorBlock.name }}</div>
      </div>
      @if(sensorBlockItem().permissions.canEdit) {
        <wr-more-menu [items]="actions()" (select)="onActionSelect($event)"></wr-more-menu>
      }
    </div>

    <div class="sensor-list">
      @if (sensorBlock.sensors.length > 0) {
        @for (sensor of sensorBlock.sensors; track sensor.id) {
          <wr-sensor-item [sensorItem]="sensor"></wr-sensor-item>
        }
      } @else {
        <div class="info-text">Keine Sensoren vorhanden</div>
      }
    </div>
  </div>
}

